var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUploadTemplate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Upload")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3807692,6.14373206 L9.05769231,6.14373206 L9.05769231,4.83819206 L13.0461538,4.83819206 C13.411802,4.83819206 13.7115385,5.12882598 13.7115385,5.49096206 L13.7115385,15.9629821 C13.7115385,16.3251496 13.4118344,16.6157521 13.0461538,16.6157521 L1.41538462,16.6157521 C1.04970402,16.6157521 0.75,16.3251496 0.75,15.9629821 L0.75,5.49096206 C0.75,5.12879451 1.04970402,4.83819206 1.41538462,4.83819206 L5.40384615,4.83819206 L5.40384615,6.14373206 L2.08076923,6.14373206 L2.08076923,15.3102121 L12.3807692,15.3102121 L12.3807692,6.14373206 Z M6.6704033,2.13741507 L5.17041326,3.44397868 C4.89962873,3.68023668 4.47459978,3.67616502 4.20827122,3.43448478 C3.92601599,3.17703041 3.93146162,2.7520053 4.21966894,2.50058765 L6.8787944,0.184391578 C7.14455407,-0.0575855705 7.56979634,-0.0619048481 7.84063536,0.174400783 L10.510799,2.50067848 C10.799437,2.75161661 10.8047237,3.1769148 10.5220492,3.43475235 C10.2561503,3.6764249 9.83091671,3.68049851 9.56037626,3.44407089 L8.06052311,2.13743657 L8.06052311,10.1060144 C8.06052311,10.4701477 7.743339,10.7523429 7.3654632,10.7523429 C6.98767232,10.7523429 6.6704033,10.4699349 6.6704033,10.1060144 L6.6704033,2.13741507 Z",
    id: "Upload",
    fill: "#335498",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadTemplate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UploadTemplate.33bbd8a1.svg";
export { ForwardRef as ReactComponent };